import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {MultiSetsPromotionModule, MultiSetsPromotionModuleEvents} from '@gongxigames/framework/promotions';

export class MultiSetsPromotionDisabledState extends ModuleState<null, MultiSetsPromotionModule, MultiSetsPromotionModuleEvents> {
    public onEnterState(): void {
        this.emit('General.UI.ENABLE', MultiSetsPromotionModule.NAME);
    }
    public onLeaveState(): void {}
    protected setupEvents(): void {}
}
